import * as React from 'react'
import { css } from 'glamor'
import { Spinner } from 'react-bootstrap'


export interface SpinnerProps {
    animation: 'border' | 'grow';
    role?: string;
    size?: 'sm';
    variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark';
    bsPrefix?: string;
}

export interface ILoadingScreenProps {
    loading: boolean
    bgColor?: string
    children?: React.ReactNode
    propsSpinner?: SpinnerProps
}

const LoadingSpinner: React.FC<ILoadingScreenProps> = ({ bgColor, loading, children, propsSpinner }) => {
    let ScreenWrapper = css({
        "position": "absolute",
        "left": "0",
        "top": "0",
        "width": "100%",
        "height": "100%",
        "textAlign": "center",
        "background": `${bgColor || 'rgba(255, 255, 255, 0.4)'}`,
        "opacity": `${loading ? 1 : 0}`,
        "visibility": `${loading ? 'visible' : 'hidden'}`,
        "transition": `opacity 0.4s,visibility -0.3s linear 0.5s`,
        "zIndex": "999"
    })

    let LoadingComponents = css({
        "position": "absolute",
        "top": "calc(50% - 4em)",
        "left": "calc(50% - 4em)",
        "display": "flex",
        "flexDirection": "column",
        "alignItems": "center",
        "transform": "translate(-50%, -50%)",
        // "zIndex":"1"
    })
    return (
        <div style={{ position: 'relative' }}>
            <div className={`${ScreenWrapper}`} >
                <div className={`${LoadingComponents}`}>

                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <span>Loading...</span>
                        <Spinner {...propsSpinner} />
                    </div>

                </div>
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}
LoadingSpinner.defaultProps = {
    propsSpinner: {
        animation: "border",
        variant: "secondary",
    }
}
export default LoadingSpinner
export { LoadingSpinner }